import { DeviceResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { DeviceService } from './device.service';
import { DeviceCategoryAndDeptNameRequest } from './dto/device-category-and-dept.request';
import { DeviceNameDto } from './dto/device-name.dto';
import { DeviceUpdateDto } from './dto/device-update.dto';
import { DeviceDto } from './dto/device.dto';
import { MacIdDto } from './dto/mac-id.dto';

@ApiTags('device')
@Controller('device')
export class DeviceController {
    constructor(private deviceService: DeviceService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    /**
     * calling a service to create a new device
     * @param deviceDto 
     * @returns 
     */
    @Post('/createDevice')
    async createDevice(@Body() deviceDto: DeviceDto): Promise<DeviceResponse>  {
        try {
        return await this.deviceService.createDevice(deviceDto);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }

    /**
     * calling a service to update a existing device
     * @param deviceDto 
     * @returns 
     */
    @Post('/updateDeviceStatus')
    async updateDeviceStatus(@Body() deviceDto: DeviceUpdateDto): Promise<DeviceResponse>  {
        try {
        return await this.deviceService.updateDeviceStatus(deviceDto);
        } catch (error) {
        return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }

    /**
     * calling a service to get all pallets
     * @returns 
     */
    @Post('getAllDevices')
    async getAllDevices():Promise<DeviceResponse> {
        try {
        return await this.deviceService.getAllDevices();
        } catch (error) {
        return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }
    
    /**
    * calling a service to devices by plant id
    * @param plantIdReq
    * @returns 
    */
    @Post('getDeviceStatusByPlantId')
    async getDeviceStatusByPlantId(@Body() plantIdReq: PlantIdRequest):Promise<DeviceResponse> {
        try {
            return await this.deviceService.getDeviceStatusByPlantId(plantIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }

    @Post('getDeviceStatusByPlantIdAndMacId')
    async getDeviceStatusByPlantIdAndMacId(@Body() macIdDto: MacIdDto): Promise<DeviceResponse> {
        try {
            return await this.deviceService.getDeviceStatusByPlantIdAndMacId(macIdDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }

    /**
     * gets all the devices for the given device category and dept name and plant
     * @param deviceCatAndDeptNameReq 
     * @returns 
     */
    @Post('getAllDevicesByDeviceCategoryAndDepartment')
    async getAllDevicesByDeviceCategoryAndDepartment(@Body() deviceCatAndDeptNameReq: DeviceCategoryAndDeptNameRequest): Promise<DeviceResponse> {
        try {
            return await this.deviceService.getAllDevicesByDeviceCategoryAndDepartment(deviceCatAndDeptNameReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }

    @Post('getDeviceDataByMacId')
    async getDeviceDataByMacId(@Body() macIdDto: DeviceNameDto): Promise<DeviceResponse> {
        try {
            return await this.deviceService.getDeviceDataByMacId(macIdDto);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(DeviceResponse, error);
        }
    }
}
